<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import { useTaskGeneralInfoUpdate } from '../../model/task-general-info-update.hook'
import TaskInfoList from './TaskInfoList.vue'
import TaskInfoItem from './TaskInfoItem.vue'
import TaskCreationPickerDeadline from './TaskCreationPickerDeadline.vue'

defineOptions({
  name: 'TaskGeneralInfoUpdate',
})

const {
  refStage,
  refStageOptions,
  refPriority,
  refPriorityOptions,
  refIsWaiting,
  refIsResolved,
  refIsCancelled,
  refWaitingReason,
  refWaitingReasonOptions,
  refWaitingReasonState,
  refResolution,
  refResolutionOptions,
  refResolutionState,
  refCustomerOutcome,
  refCustomerOutcomeOptions,
  refCustomerOutcomeState,
  refCancelReason,
  refCancelReasonOptions,
  refCancelReasonState,
} = useTaskGeneralInfoUpdate()
</script>

<template>
  <TaskInfoList>
    <TaskInfoItem title="Stage">
      <AppSelect
        v-model="refStage"
        :options="refStageOptions"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem title="Priority">
      <AppSelect
        v-model="refPriority"
        :options="refPriorityOptions"
        placeholder="Select here"
      />
    </TaskInfoItem>
    <TaskInfoItem
      v-if="refIsWaiting"
      title="Waiting reason"
      required
    >
      <AppSelect
        v-model="refWaitingReason"
        :options="refWaitingReasonOptions"
        :state="refWaitingReasonState"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem
      v-if="refIsResolved"
      title="Resolution"
      required
    >
      <AppSelect
        v-model="refResolution"
        :options="refResolutionOptions"
        :state="refResolutionState"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem
      v-if="refIsResolved"
      title="Customer outcome"
      required
    >
      <AppSelect
        v-model="refCustomerOutcome"
        :options="refCustomerOutcomeOptions"
        :state="refCustomerOutcomeState"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem
      v-if="refIsCancelled"
      title="Cancel reason"
      required
    >
      <AppSelect
        v-model="refCancelReason"
        :options="refCancelReasonOptions"
        :state="refCancelReasonState"
        placeholder="Select here"
        clearable
      />
    </TaskInfoItem>
    <TaskInfoItem title="Deadline">
      <TaskCreationPickerDeadline />
    </TaskInfoItem>
  </TaskInfoList>
</template>
